import React from 'react'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider } from '@mui/material/styles';
import constants from '../../utils/constants';

const index = ({ value, className, mode, name, onChange, help, options,design }) => {

  const handleChange = (event) => {
    onChange(event);
  };

  return (
    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <Tooltip title={help} placement="top">
        <FormControl className={className ?? undefined}>
          <FormLabel id="demo-controlled-radio-buttons-group" style={{ fontSize: "inherit",fontWeight: '600', lineHeight: "inherit" }}>{design !== 'table' ? name : null}</FormLabel>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={handleChange}
          >
            {options.map((item) => (
              <FormControlLabel value={item.value} control={<Radio inputProps={{ readOnly: mode }} />} label={<span style={{ height: '1px', fontSize: "inherit",fontWeight: '600', lineHeight: "inherit" }}>{item.name}</span>} />
            ))}
          </RadioGroup>
        </FormControl>
      </Tooltip>
    </ThemeProvider>
  )
}

export default index